<template>
    <div :class="preCls + 'content-box'"
        style="position: relative;">
        <Row :gutter="20">
            <Col span="8">
                <Table
                    ref="mt"
                    highlight-row
                    :columns="arrange"
                    :data="orgList"
                    :height="mtHeight"
                    @on-current-change="selectOrg"
                >
                </Table>
            </Col>
            <Col span="16">
                <div :style="tableHead">
                    <span>功能授权</span>
                </div>
                <div :style="containerStyle">
                    <auth-resources
                        v-if="!loading"
                        ref="authRes"
                        :style="authStyle"
                        :resTree="resTree"
                        :orgAuth="orgAuth"
                    ></auth-resources>
                    <Spin v-else fix size="large"></Spin>
                </div>
            </Col>
        </Row>
        <div :class="preCls + 'bottom-abs-box'">
            <Button
                style="width: 120px"
                type="primary"
                @click="saveAuth"
                :loading="submitLoading"
                >保存</Button
            >
        </div>
    </div>
</template>
<script type="text/javascript">
import { listToTree } from '_u/helper'
import { resTree, orgAuth } from '@/api/sys-res'
import { queryOrgAuth, orgList } from '@/api/sys-org'
import { anchorCell, pipeCell, mapCell } from '@/components/grid/renderCell'
import AuthResources from './authResources'

const WINDOW_HEIGHT = document.body.clientHeight

export default {
    components: {
        AuthResources,
    },
    data() {
        return {
            submitLoading: false,
            loading: false,
            mtHeight: 360,

            orgId: '',
            orgList: [],

            resTree: [],
            orgAuth: [],
        }
    },
    computed: {
        tableHead() {
            return {
                background: this.$theme.tableTheadBg,
                lineHeight: '18px',
                padding: '10px 14px',
                fontWeight: 'bold',
                border: '1px solid #dcdee2',
                borderBottom: 0,
            }
        },

        tableStyle() {
            return {
                position: 'relative',
                height: this.mtHeight + 40 + 'px',
                background: '#FFFFFF',
            }
        },

        authStyle() {
            return {
                padding: '0 18px',
            }
        },

        arrange() {
            return [
                {
                    title: '岗位名称',
                    key: 'name',
                    align: 'left',
                },
            ]
        },

        containerStyle() {
            return {
                height: this.mtHeight - 39 + 'px',
                border: '1px solid #e8eaec',
                overflowY: 'auto',
            }
        },
    },
    methods: {
        saveAuth() {
            this.loading = true
            this.submitLoading = true
            this.save()
                .then(() => this.fetchAuth())
                .then((args) => this.setAuth(args))
                .finally(() => {
                    this.loading = false
                    this.submitLoading = false
                })
        },

        selectOrg(row) {
            this.submitLoading = true
            this.orgAuth = []
            let orgIsUpdate = this.$refs.authRes.checkUpdate()
            Promise.resolve()
                .then(() => {
                    if (orgIsUpdate) {
                        return this.save()
                    }
                })
                .then((res) => {
                    this.orgId = row.id
                })
                .then(() => this.fetchAuth())
                .then((args) => this.setAuth(args))
                .finally(() => {
                    this.loading = false
                    this.submitLoading = false
                })
        },
        save() {
            if (this.orgId) {
                let resourceIds = this.$refs.authRes.getResIds().join(','),
                    isShowSaveSuccess = false
                let body = {
                    orgId: this.orgId,
                    resourceIds,
                }
                this.loading = true
                return Promise.all([orgAuth(body)]).then(() =>
                    this.$Message.success(this.$t('tips.save.success'))
                )
            } else {
                this.$Message.error('请选择一个岗位!')
                return Promise.reject()
            }
        },

        fetchAuth() {
            this.loading = true
            return Promise.all([
                resTree({
                    userId: this.$store.state.user.info.id
                }),
                queryOrgAuth(this.orgId),
            ])
        },

        setAuth(args) {
            var [resTree, Auth] = args
            this.resTree = resTree.data.list
            this.orgAuth = Auth.data.resourceList
            this.loading = false
        },

        setOrgData(data) {
            var me = this

            listToTree(data.list, {
                done(tree, map, list) {
                    function getFullName(node) {
                        var fullName = node.name,
                            parent = map[node.pid]

                        while (parent) {
                            fullName = parent.name + '-' + fullName

                            parent = map[parent.pid]
                        }

                        return fullName
                    }

                    // 所有岗位
                    var gangwei = list.filter((v) => v.orgLevel == 4)
                    gangwei.forEach((v) => (v.name = getFullName(v)))

                    if (gangwei.length > 0) {
                        gangwei[0]._highlight = true
                        me.orgList = gangwei
                        me.orgId = gangwei[0].id
                    }
                },
            })
        },
    },

    created() {
        this.loading = true
        this.submitLoading = true
        orgList()
            .then((res) => this.setOrgData(res.data))
            .then((res) => this.fetchAuth())
            .then((args) => this.setAuth(args))
            .finally(() => {
                this.loading = false
                this.submitLoading = false
            })
    },

    watch: {},

    mounted() {
        var me = this
        this.$nextTick(() => {
            var mt = this.$refs.mt
            me.mtHeight =
                WINDOW_HEIGHT - mt.$el.getBoundingClientRect().top - 52
        })
    },
}
</script>
